import React from 'react';

export default () => (
  <nav className="footer">
    <div>
      <div>
        <img src="images/GitHub-Mark-Light-32px.png" alt="" />
        <span>View on github :</span>
      </div>
    </div>
    <div>
      <a href="https://github.com/aileo/web-control-plus">Sources</a>
    </div>
    <div>
      <a href="https://github.com/aileo/web-control-plus/issues">Issues</a>
    </div>
  </nav>
);
